import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, forwardRef, useState, useEffect, useCallback, } from "react";
import { ArrowLeftOutlined, FullscreenOutlined, FullscreenExitOutlined, } from "@ant-design/icons";
import { Button, Modal, notification } from "antd";
import AssetMapDetail from "@/components/AssetMapDetail";
import Marquee from "@/components/Marquee";
import { whApi } from "@/api/whApi";
import { mmsApi } from "@/api/mmsApi";
import { wmsApi } from "@/api/wmsApi";
import axios from "axios";
const AssetMap3D = forwardRef(({ className = "", fontSize = 16 }, ref) => {
    const [api, contextHolder] = notification.useNotification();
    const elementRef = useRef(null);
    const [isFullscreen, setFullscreen] = useState(!!document.fullscreenElement);
    const toggleFullsreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
            setFullscreen(false);
        }
        else {
            elementRef.current?.requestFullscreen();
            setFullscreen(true);
        }
        setSelectedAssetDetail(null);
    };
    const [urlData, setUrlData] = useState(null);
    const childRef = useRef(null);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [selectedAssetDetail, setSelectedAssetDetail] = useState(null);
    const [assetTitle, setAssetTitle] = useState("");
    const [cameraLock, setCameraLock] = useState(false);
    const activePoint = useRef({ x: 0, y: 0 });
    const unselectedAsset = async () => {
        setSelectedAssetDetail(null);
        setSelectedAsset(null);
        let res = await whApi.getWarehouse();
        let { warehouseName: name = "中心库", shelfTotal, slotTotal, assetTotal, assetAmount, } = res.data || {};
        setSelectedAsset({
            name,
            shelfTotal,
            slotTotal,
            assetTotal,
            assetAmount,
        });
    };
    const openNotification = () => {
        api.info({
            message: "通知提示",
            description: "货位灯已亮",
            placement: "topRight",
            duration: 3,
        });
    };
    const onBuildingEnter = (name, id) => {
        setAssetTitle(name);
    };
    const onBuildingLeave = (name, id) => {
        setAssetTitle("");
    };
    const onBuildingClick = async (name, id) => {
        setSelectedAsset(null);
        let res = await whApi.getInfoByShelfCode(name);
        let { shelfName: pointName, shelfCode, slotQty: slots, availSlotQty: availSlots, usedSlotQty: usedSlots, vacancyRate, } = res.data || {};
        setSelectedAsset({
            id: shelfCode,
            slotTotal: slots,
            pointName,
            availSlots,
            usedSlots,
            vacancyRate,
        });
    };
    const onCameraFocus = () => {
        setCameraLock(true);
    };
    const onCameraBlur = () => {
        setSelectedAsset(null);
        setSelectedAssetDetail(null);
        setCameraLock(false);
        setAssetTitle("");
        unselectedAsset();
    };
    let getPointName = function (name = "") {
        let regex = /^H(\d+)-(\d+)-(\d+)$/;
        let match = name.match(regex);
        if (!match)
            return name;
        let num1 = Number(match[2]) < 10 ? "0" + match[2] : match[2];
        let num2 = Number(match[3]) < 10 ? "0" + match[3] : match[3];
        return [num1, num2].join("-");
    };
    const onPointEnter = (name, id) => {
        setAssetTitle(getPointName(name));
    };
    const onPointClick = async (buildingInfo, pointInfo) => {
        let { pointerX, pointerY } = pointInfo;
        activePoint.current = { x: pointerX, y: pointerY };
        setSelectedAssetDetail(null);
        let pointId = buildingInfo.pointId;
        let pointName = `${buildingInfo.name}-${getPointName(buildingInfo.pointName)}`;
        let res = await wmsApi.getInfoBySlotCode(pointName);
        let data = res.rows || [];
        setSelectedAssetDetail({
            id: pointId,
            name: pointName,
            detail: {
                id: pointName,
                label: "资产详情单",
                btnList: linkAddress,
                list: data.map((d) => ({
                    name: d.assetName,
                    value: d.qty,
                })),
            },
        });
    };
    var linkAddress = [];
    let removeLeadingZeros = function (str) {
        const match = str.match(/^H(\d+)-(\d+)-(\d+)$/);
        if (!match)
            return str;
        let firstNum = parseInt(match[1]);
        const secondNum = parseInt(match[2]);
        const thirdNum = parseInt(match[3]);
        if (firstNum == 18)
            firstNum = 33;
        else if (firstNum > 18)
            firstNum -= 1;
        return `H${String(firstNum).padStart(2, "0")}-${Number(secondNum)}-${Number(thirdNum)}`;
    };
    const onLoad = () => {
        unselectedAsset();
        mmsApi.getLinkAddress().then((res) => {
            if (Array.isArray(res.data))
                linkAddress = res.data.map((data) => ({
                    type: "button",
                    ...data,
                }));
            else
                linkAddress = [];
        });
        return new Promise((resolve, reject) => {
            resolve({});
            //   whApi
            //     .getSlotHasVehicle()
            //     .then((res) => {
            //       let { data = [] } = res;
            //       if (!data.length) return resolve({});
            //       let hideMeshes = data.map((d: string) => ({
            //         parentNode: removeLeadingZeros(d),
            //       }));
            //       resolve({ hideMeshes });
            //     })
            //     .catch((err) => {
            //       resolve({});
            //     });
        });
    };
    const hasSelected = useRef(false);
    const onViewMatrixChangedObservable = () => {
        if (hasSelected.current) {
            setSelectedAssetDetail(null);
        }
    };
    const convertToRangeStr = (str) => {
        // 第一步：校验原始字符串格式（匹配 XXX-XX-XX，最后两位是 01-12）
        const regex = /^(.+)-([01][0-9]|0[1-9])$/; // 捕获前缀（.+-）和最后两位（01-12）
        const match = str.match(regex);
        if (!match) {
            console.warn(`无效格式：${str}，请输入 XXX-XX-XX 格式（最后两位 01-12）`);
            return str; // 格式错误返回原始字符串
        }
        // 第二步：提取前缀和最后两位数字
        const prefix = match[1]; // 前缀（如 "H33-01"）
        const lastTwo = match[2]; // 最后两位（如 "09"）
        const num = parseInt(lastTwo, 10);
        // 第三步：匹配区间后缀
        let rangeSuffix = "";
        if (num >= 1 && num <= 4) {
            rangeSuffix = "01~04";
        }
        else if (num >= 5 && num <= 8) {
            rangeSuffix = "05~08";
        }
        else if (num >= 9 && num <= 12) {
            rangeSuffix = "09~12";
        }
        // 第四步：重组字符串（前缀 + "-" + 区间后缀）
        return `${prefix}-${rangeSuffix}`;
    };
    //亮灯
    const lightByLightMode = (mac) => {
        try {
            axios
                .post("http://192.168.10.101:5001/prod-api/iot/easyfinder/bgTag/lightByLightModeId", {
                tagMacs: [mac],
                gatewayMacList: [],
                lightOff: false,
                lightModeId: 96,
            }, {
                headers: {
                    Authorization: localStorage.getItem("othtertoken"),
                    "Content-Type": "application/json",
                    language: "zh_CN",
                },
                // 可选：其他配置（如超时、查询参数等）
                timeout: 5000, // 超时时间 5 秒
                withCredentials: true,
            })
                .then((response) => { })
                .catch((error) => {
                console.error("GET 请求失败：", error.message); // 错误处理
            });
        }
        catch (err) { }
    };
    const btnClick = (selectedAssetDetail, d) => {
        if (localStorage.getItem("easyfinder") != null) {
            let _easyfinder = JSON.parse(localStorage.getItem("easyfinder"));
            let hj = selectedAssetDetail.name?.slice(0, 3); //货架亮灯编号
            //1个货位亮灯标签对应4个货位，获取亮灯标签编号
            let hw = convertToRangeStr(selectedAssetDetail.name); ////货位亮灯编号
            let hj_mac = ""; //货架灯光mac
            let hw_mac = ""; //货位灯光mac
            for (let i = 0; i < _easyfinder.length; i++) {
                if (_easyfinder[i].tagNo == hj) {
                    hj_mac = _easyfinder[i].tagMac;
                }
                if (_easyfinder[i].tagNo == hw) {
                    hw_mac = _easyfinder[i].tagMac;
                }
            }
            lightByLightMode(hj_mac);
            openNotification();
            setTimeout(() => {
                lightByLightMode(hw_mac);
            }, 5000);
        }
        else {
            window.open(d.url + `?slodCode=${selectedAssetDetail.detail.id}`, "_blank");
        }
        // setUrlData(d.url+`?slodCode=${selectedAssetDetail.detail.id}`)
    };
    useEffect(() => {
        hasSelected.current = !!selectedAssetDetail;
    }, [selectedAssetDetail]);
    const tipsRefCallback = useCallback((node) => {
        if (node && elementRef.current) {
            const rect1 = elementRef.current.getBoundingClientRect();
            const rect2 = node.getBoundingClientRect();
            if (rect2.right > rect1.right) {
                node.style.left = activePoint.current.x - rect2.width + "px";
            }
            if (rect2.left < rect1.left) {
                node.style.left = rect1.left + "px";
            }
            if (rect2.top < rect1.top) {
                node.style.top = activePoint.current.y + 20 + "px";
            }
            if (rect2.bottom > rect1.bottom) {
                node.style.top = activePoint.current.y - rect2.height + "px";
            }
        }
    }, []);
    return (_jsxs("div", { className: "relative h-full", ref: elementRef, children: [contextHolder, _jsx(AssetMapDetail, { ref: childRef, className: "h-full", jsonUrl: "assets/models/cangku.json", fontSize: fontSize, onBuildingEnter: onBuildingEnter, onBuildingLeave: onBuildingLeave, onBuildingClick: onBuildingClick, onCameraFocus: onCameraFocus, onCameraBlur: onCameraBlur, onPointClick: onPointClick, onPointEnter: onPointEnter, onLoad: onLoad, onViewMatrixChangedObservable: onViewMatrixChangedObservable }), _jsx("div", { className: "absolute top-[0.1rem] right-[0.1rem] z-10 flex items-center gap-[0.2rem]", children: _jsx("a", { className: "text-white text-[0.24rem] font-medium cursor-pointer", onClick: toggleFullsreen, title: "切换全屏" + isFullscreen, children: isFullscreen ? _jsx(FullscreenExitOutlined, {}) : _jsx(FullscreenOutlined, {}) }) }), cameraLock && (_jsx("div", { className: "absolute top-0 left-1", style: { top: "-.75rem" }, children: _jsx(Button, { style: {
                        background: "color-mix(in oklab, var(--color-gray-900) 38%, transparent)",
                    }, onClick: () => {
                        childRef?.current?.cameraBlur?.();
                    }, size: "large", color: "default", variant: "solid", shape: "circle", icon: _jsx(ArrowLeftOutlined, {}) }) })), selectedAsset && (_jsx("div", { className: "absolute top-[0.1rem] right-[0.4rem] z-20 text-white border bg-gray-900/38 border-gray-600/0 min-w-8", style: {
                    animation: "fadeInRight 1s both",
                    padding: 10,
                    borderRadius: 10,
                }, children: _jsxs("div", { className: "text-xs", style: { fontSize: `${fontSize / 100}rem`, lineHeight: 1.6 }, children: [_jsxs("div", { className: "flex justify-between", style: { marginBottom: 5 }, children: [_jsxs("span", { className: "flex items-center text-white", children: [_jsx("img", { src: "assets/images/icon01.png", style: { width: 20, height: 21, marginRight: 10 } }), "\u5E93\u623F/\u8D27\u67B6\u4FE1\u606F"] }), _jsx("span", {})] }), selectedAsset.name != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u5E93\u623F\u540D\u79F0:" }), _jsx("span", { children: selectedAsset.name })] })), selectedAsset.shelfTotal != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u8D27\u67B6\u6570:" }), _jsx("span", { children: selectedAsset.shelfTotal })] })), selectedAsset.pointName != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u8D27\u67B6\u7F16\u7801:" }), _jsx("span", { children: selectedAsset.pointName })] })), selectedAsset.slotTotal != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u8D27\u4F4D\u603B\u6570:" }), _jsx("span", { children: selectedAsset.slotTotal })] })), selectedAsset.availSlots != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u8D27\u4F4D\u7A7A\u95F2\u6570:" }), _jsx("span", { children: selectedAsset.availSlots })] })), selectedAsset.usedSlots != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u5DF2\u7528\u8D27\u4F4D\u6570:" }), _jsx("span", { children: selectedAsset.usedSlots })] })), selectedAsset.vacancyRate != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u7A7A\u7F6E\u7387:" }), _jsxs("span", { children: [selectedAsset.vacancyRate, "%"] })] })), selectedAsset.assetTotal != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u7269\u8D44\u603B\u6570:" }), _jsx("span", { children: selectedAsset.assetTotal })] })), selectedAsset.assetAmount != undefined && (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u7269\u8D44\u91D1\u989D:" }), _jsx("span", { children: selectedAsset.assetAmount })] }))] }) })), selectedAssetDetail && (_jsxs("div", { className: "absolute top-0 left-0 z-20 w-6 text-white border bg-gray-900/38 border-gray-600/0 min-w-8", ref: tipsRefCallback, style: {
                    animation: "fadeIn 1s both",
                    padding: ".1rem",
                    borderRadius: ".1rem",
                    margin: ".05rem",
                    left: activePoint.current.x + "px",
                    top: activePoint.current.y + "px",
                    marginLeft: ".05rem",
                }, children: [_jsxs("div", { className: "flex items-center justify-between", style: { marginBottom: ".05rem" }, children: [_jsxs("span", { className: "flex items-center text-white", style: { fontSize: `${fontSize / 100}rem` }, children: [_jsx("img", { src: "assets/images/icon02.png", style: {
                                            width: ".12rem",
                                            height: ".12rem",
                                            marginRight: ".1rem",
                                        } }), "\u8D27\u4F4D\u4FE1\u606F:"] }), _jsx("button", { onClick: () => setSelectedAssetDetail(null), className: "text-white-400 hover:text-white", style: { fontSize: `${fontSize / 100}rem` }, children: "\u2715" })] }), _jsxs("div", { className: "text-xs", style: { fontSize: `${fontSize / 100}rem`, lineHeight: 1.6 }, children: [_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: "\u8D27\u4F4D\u7F16\u7801:" }), _jsx("span", { children: selectedAssetDetail.name })] }), selectedAssetDetail.detail && (_jsxs("div", { className: "flex justify-between", children: [_jsxs("span", { className: "text-gray-300", style: { fontSize: `${fontSize / 100}rem` }, children: [selectedAssetDetail.detail.label, ":"] }), _jsx("span", {})] })), selectedAssetDetail.detail && (_jsx(Marquee, { animate: selectedAssetDetail.detail.list.length > 8, duration: selectedAssetDetail.detail.list.length * 1.25, children: selectedAssetDetail.detail.list.map((d, i) => {
                                    return (_jsxs("div", { className: "flex justify-between", children: [_jsx("span", { className: "text-gray-300", children: d.name ? d.name + ":" : "" }), _jsx("span", { children: d.value })] }, i));
                                }) })), selectedAssetDetail.detail &&
                                selectedAssetDetail.detail.btnList.map((d, i) => {
                                    return (_jsx("a", { onClick: () => btnClick(selectedAssetDetail, d), style: {
                                            marginRight: ".08rem",
                                            marginTop: ".08rem",
                                            fontSize: `${fontSize / 100}rem`,
                                            padding: ".02rem .07rem",
                                            borderRadius: ".04rem",
                                            display: "inline-block",
                                            backgroundColor: d.bgColor,
                                            color: d.fontColor,
                                            cursor: "pointer",
                                        }, children: d.name }, i));
                                })] })] })), assetTitle && (_jsx("div", { className: "absolute top-[0.1rem] z-20 text-white transform -translate-x-1/2 border left-1/2 bg-gray-900/38 border-gray-600/0 min-w-1", style: { padding: ".1rem", borderRadius: ".1rem" }, children: _jsx("div", { style: { fontSize: `${fontSize / 100}rem` }, children: assetTitle }) })), _jsx(Modal, { className: "fullscreen-modal", open: !!urlData, onCancel: () => setUrlData(null), width: "calc(100vw - 0px)", style: { top: 0, paddingBottom: 0 }, destroyOnHidden: true, children: _jsx("iframe", { src: urlData ? urlData : "", className: "inset-0 w-full h-full border-0", allowFullScreen: true }) }), _jsx("style", { children: `
            .fullscreen-modal {
              margin: 0
            }
            .fullscreen-modal .w-full {
              width:100vw;
            }
            .fullscreen-modal .h-full {
              height: 100vh
            }
            .fullscreen-modal .ant-modal {
              max-width: 100vw;
              width: 100vw !important;
              top: 0;
              height: 100vh;
              padding-bottom: 0;
            }
            .fullscreen-modal .ant-modal-content {
              width: 100vw;
              height: 100vh;
              display: flex;
              flex-direction: column;
              padding: 0
            }
            .fullscreen-modal .ant-modal-body {
              flex: 1;
              overflow-y: auto;
            }
            .fullscreen-modal .ant-modal-footer {
              display:none
            }
            .fullscreen-modal .ant-modal-close {
              width: 40px;
              height: 40px;
              background: white;
              border-radius: 50%;
              color: black
            }
              .ant-notification-notice-wrapper {
              z-index: 9999 !important;
            }
            ` })] }));
});
export default AssetMap3D;
